import React , { useState }  from "react";
import { useNavigate } from 'react-router-dom';

import "../css/common.css";

import imageOne from "../resource/meditate/F15 (2).png";
import imageOtwo from "../resource/meditate/F15.png";
import imageThree from "../resource/meditate/F16.png";
import imageFour from "../resource/meditate/L18.png";
import imageFive from "../resource/meditate/L19.png";
import imageSix from "../resource/meditate/L22.png";
import imageSeven from "../resource/meditate/L21.png";
import imageEight from "../resource/meditate/L20.png";
import imageNine from "../resource/meditate/F14.png";

import TitleChnage from "../Hook/TitleChnage";

const Meditate = () => {

  const navigate = useNavigate();
  TitleChnage("Meditate");

  const [isTextVisible,setIsTextVisible] = useState(false);

        const handleToggle = () => {
            setIsTextVisible((prev) => !prev);
        }


  const handleClick = (event) => {

    const pathMap = {
        externalRetreats:"/externalRetreats",
        guestspeakers : "/guestspeakers",
        ordination : "/ordination",
        internalRetreats:"/internalRetreats",
        soloRetreat:"/soloRetreat"
    }

    const path = event.currentTarget.id;
    const targetPath = pathMap[path]

    if (targetPath) {
        navigate(targetPath)
    }
}

  return (
    <div className="page meditate-page">
      <img src={imageOne} alt="" className="left-imge" />
      <img src={imageOtwo} alt="" className="right-imge" />

      <header>
        <div className="home-icon">{/* <img src="#" alt="Home Icon"> */}</div>
        <div className="title">
          <h1>Meditate With Us</h1>
          <img src={imageThree} width={400} />
        </div>
      </header>

      <section className="intro-text">
        <p className="title-text ">
        Yogā ve jayati bhuri, ayogā ve sankhāya"
        Dhammapada
        </p>
        <p className="title-text ">
        He who meditates accrues wisdom, 
        </p>
        <p className="title-text ">
        while he who deviates from meditation is destined to deteriorate
        </p>

        <p className="p-4 text-bold dark-gold text-left mt-5">
        Welcome to the Bhaddeka Vihari Meditation Centre.
        </p>
        <p className="meditate-info ">
          Bhaddeka Vihari Retreat Center is situated in a quiet and serene
          countryside suburb, surrounded by lush 
          <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "" : "more"}</span>
        </p>

        {isTextVisible &&
                <div className="hidden-text">
                  <p className="meditate-info ">green farmlands,  making it an
          ideal retreat to escape the hustle and bustle if city life. Since its
          establishment in 2017, the monastery has been hosting retreat led by
          various prominent teachers of the Theravada traditon. These teachers
          elucidate the discourse of the Lord Buddha, assisting the community in
          deepening their understanding of Dhamma, integrating these teachings
          into daily life, and developing their meditation practices.</p>
                  <p className="title-text text-left p-4 mt-5">Significance of having a Retreat</p>
                <p className="dana-info ">It is worth noting that contemporary society is rapidly advancing in technology, significantly easing business operations and communication engagements, and saving a substantial amount of time compared to a decade ago. While technology is an incomparable tool for success, if not used effectively to improve one's livelihood, it can harm one's mental health consume the saved time. The constant exposure to endless entertainment, news, and events through communication channels can entangle individuals in emotional turmoil, limiting their peace and tranquility.</p>
                <p className="dana-info ">In such a situation, the Bhaddeka Vihari Monsatery and Retreat Centre provide the teachings and guidance necessary to enhance the mental strength of the community. Variety of activities and programs organized by the Monastery   helps to relieve the mind and body in a quiet and charming atmosphere. The Dhamma discourses and teachings pave the way to relax the mind and enjoy tranquility, leading to a harmonious life.
          <span className='lowertext curser-pointer' onClick={handleToggle}>{isTextVisible ? "less" : ""}</span>

                </p>
                </div>
                }
      </section>

      <section className="button-section">
        <div className="left-col">
        <img src={imageFive} alt="" width={250}  onClick={handleClick} id="internalRetreats"/>
          <img src={imageFour} alt="" width={250} id="externalRetreats" onClick={handleClick} />
        </div>
        <div className="middle-col">
          <img src={imageSix} alt="" width={200}  onClick={handleClick} id="soloRetreat" />
        </div>
        <div className="right-col">
          <img src={imageSeven} alt="" width={250} id="guestspeakers"  onClick={handleClick}/>
          <img src={imageEight} alt="" width={250} onClick={handleClick} id="ordination" />
        </div>
      </section>

      <div className="box">
        <img src={imageNine} alt="" className="bottom-imge" />
      </div>
    </div>
  );
};

export default Meditate;
